module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "province-F"
  }, [_c('div', {
    staticClass: "tabArea"
  }, [_c('div', {
    staticClass: "seekArea"
  }, [_c('div', {
    staticClass: "selectBox"
  }, [_c('span', [_vm._v("资质：")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.selType),
      callback: function($$v) {
        _vm.selType = $$v
      },
      expression: "selType"
    }
  }, _vm._l((_vm.Zizhi), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "selectBox"
  }, [_c('span', [_vm._v("省局：")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "230px"
    },
    attrs: {
      "size": "small",
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.selProvinceId),
      callback: function($$v) {
        _vm.selProvinceId = $$v
      },
      expression: "selProvinceId"
    }
  }, _vm._l((_vm.Shengju), function(item) {
    return _c('el-option', {
      key: item.sjExamineId,
      attrs: {
        "label": item.sjExamine,
        "value": item.sjExamineId
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "selectBox"
  }, [_c('span', [_vm._v("年份：")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "size": "small",
      "placeholder": "历年记录"
    },
    model: {
      value: (_vm.selYear),
      callback: function($$v) {
        _vm.selYear = $$v
      },
      expression: "selYear"
    }
  }, _vm._l((_vm.selYearRecord), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "selectBox"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.goSeek
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "size": "small",
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": _vm.goExport
    }
  }, [_vm._v("导出")])], 1)]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tabDats,
      "border": "",
      "height": this.tableHeight
    },
    on: {
      "sort-change": this.handleSortChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "organizationName",
      "label": "出版单位",
      "width": "180",
      "fixed": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "provinceName",
      "label": "所属省局",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.selYear + '年'
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "firstTotalSales",
      "label": "出版单位年销售收入（万元）",
      "width": "230",
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "firstTotalProfit",
      "label": "出版单位年利润收入（万元）",
      "width": "230",
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "firstSales",
      "label": (_vm.selType == 1 ? '音像制品' : '电子出版物') + '年销售收入（万元）',
      "width": "230",
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "firstProfit",
      "label": (_vm.selType == 1 ? '音像制品' : '电子出版物') + '年利润总额（万元）',
      "width": "230",
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "firstPublicationVariety",
      "label": "出版物品种数量",
      "width": "200",
      "sortable": "custom"
    }
  })], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": (_vm.selYear * 1 + 1) + '年'
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "secondTotalSales",
      "label": "出版单位年销售收入（万元）",
      "width": "230",
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "secondTotalProfit",
      "label": "出版单位年利润收入（万元）",
      "width": "230",
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "secondSales",
      "label": (_vm.selType == 1 ? '音像制品' : '电子出版物') + '年销售收入（万元）',
      "width": "230",
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "secondProfit",
      "label": (_vm.selType == 1 ? '音像制品' : '电子出版物') + '年利润总额（万元）',
      "width": "230",
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "secondPublicationVariety",
      "label": "出版物品种数量",
      "width": "200",
      "sortable": "custom"
    }
  })], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-209b92d0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/adminRole/adminPublishOperation.vue
// module id = 1693
// module chunks = 1